import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=af6f90c0&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Dialog.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Dialog.vue?vue&type=style&index=1&id=af6f90c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6f90c0",
  null
  
)

export default component.exports